import {
  AuthControllerLoginRequest,
  AuthControllerRefreshBubbleTokenRequest,
  ResponseError,
} from '@cratehackers/api-client';
import { startTransition } from 'react';
import { on, run } from '../helper/electron';
import ApiService from '../services/Api.service';
import {
  AppIdentifiers,
  getToken,
  setToken,
} from '../store/slices/token-state.slice';
import { getAppStore } from '../store/storeRef';
import isElectron from './isElectron';
import { logout } from './logout';

/******************************************************************************
 * For refreshing the bubble token ultimately. The app token is a side bonus
 ******************************************************************************/
export const refreshToken_old = async (): Promise<void> => {
  const email = localStorage.getItem('email');

  if (!email || !isElectron()) {
    logout();
    throw new Error('No credentials');
  }
  run('get-credentials', { email });
  const savedPassword = await new Promise<string>((resolve) => {
    on('get-credentials', (password: string) => resolve(password));
  });

  if (!savedPassword) {
    logout();
    throw new Error('No credentials');
  }
  const chApi = ApiService.getApiClient();

  const requestParams: AuthControllerLoginRequest = {
    loginEmailPasswordDto: {
      email: email,
      password: savedPassword,
    },
  };
  try {
    const data: any = await chApi.authControllerLogin(requestParams);
    startTransition(() => {
      getAppStore().dispatch(
        setToken(
          AppIdentifiers.App,
          data.access_token,
          null, // TODO: Will bubble ever have a refresh token?
          Number(data.bubble_expiration),
        ),
      );
    });
  } catch (err: any) {
    if (err instanceof ResponseError) {
      const body = await err.response.json();
      console.error(
        'Refresh failed with API error:',
        err.response.status,
        body,
      );
    } else {
      console.error('Unexpected refresh error:', err);
    }
    logout();
    throw new Error('RefreshFailed');
  }
};

export const refreshToken = async (): Promise<void> => {
  const email = localStorage.getItem('email');

  if (!email || !isElectron()) {
    logout();
    throw new Error('No credentials');
  }
  run('get-credentials', { email });
  const savedPassword = await new Promise<string>((resolve) => {
    on('get-credentials', (password: string) => resolve(password));
  });

  if (!savedPassword) {
    logout();
    throw new Error('No credentials');
  }
  const chApi = ApiService.getApiClient();

  const requestParams: AuthControllerRefreshBubbleTokenRequest = {
    refreshBubbleTokenDto: {
      email: email,
      password: savedPassword,
    },
  };
  try {
    const data: any =
      await chApi.authControllerRefreshBubbleToken(requestParams);

    console.log('Token_expiration_date' + data);

    const appToken = getToken('app');

    console.log('Previous_APP_Token' + JSON.stringify(appToken));

    if (appToken) {
      startTransition(() => {
        getAppStore().dispatch(
          setToken(
            AppIdentifiers.App,
            appToken.accessToken,
            appToken.refreshToken,
            Number(data),
          ),
        );
      });
    }
  } catch (err: any) {
    if (err instanceof ResponseError) {
      const body = await err.response.json();
      console.error(
        'Refresh failed with API error:',
        err.response.status,
        body,
      );
    } else {
      console.error('Unexpected refresh error:', err);
    }
    logout();
    throw new Error('RefreshFailed');
  }
};
